import { connect as connectRedux } from 'react-redux';
import { compose, hoistStatics } from 'recompose';


export const connect = (mapReduxToProps, mapDispatchToProps, mergeProps) => {
  return hoistStatics(compose(
    connectRedux(mapReduxToProps, mapDispatchToProps, mergeProps)
  ));
};
